import styled from 'styled-components';
import { SBoldPrimaryText } from 'styles/components';

type SSubjectProps = {
    isCompleted: boolean;
};

export const SSubject = styled(SBoldPrimaryText)<SSubjectProps>`
    ${({ isCompleted }) => (isCompleted ? 'text-decoration: line-through;' : '')}
`;

export const SCard = styled.div<{ isEven: boolean }>`
    background-color: ${({ theme, isEven }) => (isEven ? theme.color.grey.lighter : theme.color.white)};
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const SCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const SCardHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    button {
        display: flex;
        align-items: center;
    }
`;

export const SCardHeaderStatus = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const SCardLine = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
`;

export const SCardLineLeft = styled.span`
    color: ${({ theme }) => theme.color.grey.light};
    font-weight: bold;
`;

export const SCardLineRight = styled.span`
    text-align: right;
`;

export const STwoLines = styled.span`
    align-items: end;
    flex-direction: column;
    display: flex;
`;
